import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';
import { RequireStaff } from '@features/cms/components/RequireStaff.tsx';

const OrdersPanelPage = lazyWithRetry(() =>
  import('@erp/orders/pages/OrdersPanelPage.tsx').then((module) => ({
    default: module.OrdersPanelPage ?? module.default,
  })),
);

const OrdersPanelRoute = () => (
  <RequireStaff render={() => <OrdersPanelPage />} />
);

const ordersNode: ComponentPage = {
  component: OrdersPanelRoute,
  handle: { breadcrumb: 'orders' },
};

const ordersRoutes: ComponentOrMapping = {
  erp: {
    orders: ordersNode,
  },
};

export default ordersRoutes;
